var map = {
	"./cs.json": [
		1373,
		1373
	],
	"./de.json": [
		44064,
		44064
	],
	"./en.json": [
		38748,
		38748
	],
	"./es.json": [
		69259,
		69259
	],
	"./fr.json": [
		59047,
		59047
	],
	"./it.json": [
		10082,
		10082
	],
	"./ja.json": [
		96458,
		96458
	],
	"./ko.json": [
		43961,
		43961
	],
	"./pl.json": [
		29727,
		29727
	],
	"./pt-br.json": [
		40622,
		40622
	],
	"./pt.json": [
		36871,
		36871
	],
	"./ru.json": [
		46350,
		46350
	],
	"./tr.json": [
		64361,
		64361
	],
	"./zh.json": [
		84621,
		84621
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 80318;
module.exports = webpackAsyncContext;